import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PROMOTION_CARDS } from '../../../../const/promotion-cards.const';
import { PromotionCardData } from '../../../../interfaces/promotion-cards.interface';

@Component({
  selector: 'app-promotion-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './promotion-card.component.html',
})
export class PromotionCardComponent {
  promotionCards: PromotionCardData[] = PROMOTION_CARDS;
}
